<template>
  <div>
    <el-menu :class="menuMode === 'vertical' ? 'vertical-menu_container' : 'horizontal-menu_container'"  :default-active="activeMenu" :mode="menuMode" @select="selectMenu">
      <el-menu-item index="messages">消息列表</el-menu-item>
      <el-menu-item index="articles">况客研究</el-menu-item>
      <el-menu-item index="focuses">轮播图</el-menu-item>
      <el-menu-item index="categories">文章分类</el-menu-item>
    </el-menu>
    <div class="data_container">
      <div class="data-header_container">
        <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="showTempInput">新建</el-button>
        <el-link class="right-direction" type="info" @click="quitSite"><i class="el-icon-s-custom"></i>退出</el-link>
      </div>
      <div class="article_container">
        <el-table
          :data="categories"
          :show-header="false"
          style="width: 100%">
          <el-table-column
          prop="name">
          </el-table-column>
          <el-table-column
            fixed="right"
            width="100">
            <template slot-scope="scope">
              <el-button class="delete-status" @click="deleteItem(scope.row)" type="text" size="small" icon="el-icon-delete">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-input
          class="temp-input"
          v-if="tempInputStatus"
          v-model="tempInputValue"
          ref="tempInput"
          size="small"
          @keyup.enter.native="createItem"
          @blur="createItem"
        >
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'categories',
  components: {
  },
  data () {
    return {
      activeMenu: 'categories',
      menuMode: 'vertical',
      categories: [],
      tempInputStatus: false,
      tempInputValue: ''
    }
  },
  async created () {
    const screenWidth = document.body.clientWidth
    if (screenWidth < 500) {
      this.menuMode = 'horizontal'
    } else {
      this.menuMode = 'vertical'
    }
    const resp = await this.$http.get('/categories/')
    if (resp.categories) {
      this.categories = resp.categories
    } else {
      this.$message({
        message: resp.error,
        type: 'warning'
      })
    }
  },
  methods: {
    selectMenu (key, keyPath) {
      if (key !== 'categories') {
        if (key === 'messages') {
          this.$router.push('/')
        } else {
          this.$router.push(`/${key}/`)
        }
      }
    },
    quitSite () {
      sessionStorage.clear()
      this.$router.push('/signin/')
    },
    async deleteItem (item) {
      const categoryId = item._id
      const resp = await this.$http.delete(`/categories/${categoryId}/`)
      if (resp.category) {
        let tempItems = this.categories
        tempItems = tempItems.filter(x => x._id !== resp.category._id)
        this.categories = tempItems
        this.$message({
          message: '移除成功',
          type: 'success'
        })
      } else {
        this.$message({
          message: resp.error,
          type: 'warning'
        })
      }
    },
    showTempInput () {
      this.tempInputStatus = true
      this.$nextTick(_ => {
        this.$refs.tempInput.$refs.input.focus()
      })
    },
    async createItem () {
      let inputValue = this.tempInputValue
      if (inputValue && inputValue.trim()) {
        if (!this.categories) {
          this.categories = []
        }
        if (this.categories.includes(inputValue.trim())) {
          this.$message({
            message: '分类已存在',
            type: 'error'
          })
          return
        }
        const { category } = await this.postCategory()
        this.categories.push(category)
      }
      this.tempInputStatus = false
      this.tempInputValue = ''
    },
    async postCategory () {
      const { tempInputValue } = this
      let resp = null
      if (tempInputValue && tempInputValue.trim()) {
        resp = await this.$http.post('/categories/', { name: tempInputValue.trim() })
      }
      return resp
    }
  }
}
</script>

<style lang="scss" scoped>
.vertical-menu_container {
  display: inline-block;
  height: 600px;
  margin: 0 0 50px 0;
  vertical-align: top;
  width: 90px;
}

.horizontal-menu_container {
  margin: 0 0 50px 0;
}

.data_container {
  box-sizing: border-box;
  display: inline-block;
  padding: 0 0 0 20px;
  width: 78%;

  .data-header_container {
    border-bottom: 1px solid #ccc;
    margin-bottom: 30px;
    overflow: hidden;
    padding-bottom: 10px;
  }

  .right-direction {
    float: right;
  }

  .close-status {
    color: #ccc;
  }

  .delete-status {
    color: #ea4335;
  }
}

.temp-input {
  margin: 10px 0 0;
  vertical-align: bottom;
}
</style>
